export default __webpack_public_path__ + "static/media/template_business-man__0007_20---orpenKisa.dbca3318.png";